import styled from 'styled-components';

export const Aside = styled.aside`
  position: sticky;
  top: 0;
  height: fit-content;
`;

export const Title = styled.h2`
  font-size: 16px;
  line-height: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 16px;
`;

export const Text = styled.button`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  display: inline-block;
  text-align: left;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 16px;
`;
